import React from 'react';

import { POLICY_LEVEL } from '../constants';
import { Star } from '../../../../../UiKit/Star/Star';
import Button from '../../../../../components/ComponentsV1/Button';
import CategoryDropdown from './CategoryDropdown';
import { useQueryCall } from '../../../../../api/react-client';
import { useClient } from '../../../../../api/api-client';
import { fetchCategoryListEndPoint } from '../../ReturnConfigDashboard/constants';

const getTextField = (name, title, placeholder, value, onChange, required) => {
  const handleChange = (e) => onChange(e.target.value);
  return (
    <div className='tw-flex tw-flex-col tw-h-max tw-gap-5 tw-flex-1'>
      <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
        {title} {required && <Star icon='*' />}
      </div>
      <div className='tw-flex tw-flex-col tw-w-full'>
        <input
          id={name}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0 focus:tw-border-none focus:tw-ring-[1.5px] tw-w-full focus:tw-ring-base-green focus:tw-border-base-green tw-border tw-border-solid tw-border-[#cfcfcf] tw-mr-6`}
          autoComplete='off'
        />
      </div>
    </div>
  );
};

const PolicyParameterForm = ({
  selectedLevel,
  orderTag,
  setOrderTag,
  itemTag,
  setItemTag,
  itemCategory,
  setItemCategory,
  itemAttrId,
  setItemAttrId,
  itemAttrValue,
  setItemAttrValue,
  isSubmitting,
  onSubmit,
}) => {
  const client = useClient();

  const { data: categories, isLoading: categoriesLoading } = useQueryCall(
    {},
    fetchCategoryListEndPoint,
    ['category', 'list'],
    () => client(`${fetchCategoryListEndPoint}`),
  );

  const options = categories?.map((category) => ({
    label: category.original_name,
    value: category.original_name,
  })) || [];
  return (
    <form onSubmit={onSubmit}>
      {selectedLevel === POLICY_LEVEL.ORDER && (
        <div className='tw-flex tw-w-full tw-h-max tw-gap-5'>
          {getTextField(
            'order_tag',
            'Tag',
            'Enter order tag',
            orderTag,
            setOrderTag,
            true,
          )}
        </div>
      )}

      {selectedLevel === POLICY_LEVEL.ITEM && (
        <div className='tw-flex tw-flex-col tw-gap-8'>
          <div className='tw-flex tw-w-full tw-h-max tw-gap-5'>
            <CategoryDropdown
              categoriesLoading={categoriesLoading}
              options={options}
              value={itemCategory}
              onChange={setItemCategory}
            />
            {getTextField(
              'item_tag',
              'Tag',
              'Enter tag',
              itemTag,
              setItemTag,
            )}
          </div>
          <div className='tw-flex tw-w-full tw-h-max tw-gap-5'>
            {getTextField(
              'item_attr_id',
              'Attribute ID',
              'Enter attribute ID',
              itemAttrId,
              setItemAttrId,
            )}
            {getTextField(
              'item_attr_value',
              'Attribute Value',
              'Enter attribute value',
              itemAttrValue,
              setItemAttrValue,
            )}
          </div>
          <div className='tw-text-[1.2rem] tw-text-zinc-500 tw-font-medium'>
            (at least 1 parameter is mandatory)
          </div>
        </div>
      )}

      <div className='tw-mt-8'>
        <Button
          title='Submit'
          disabled={isSubmitting}
        />
      </div>
      <div className='tw-text-[1.2rem] tw-text-zinc-500 tw-font-medium tw-mt-2'>
        Submit will fetch the policy if it exists else give an option to create a new one
      </div>
    </form>
  );
};

export default PolicyParameterForm;
